/**
 * «Распределение» → «Сделки» → «Сделки в работе» — `GET /api/deals/distribution/inwork`.
 * Спека `docs/specs/2026-09-30-deals-inwork-design.md`.
 */
import { apiFetch } from "@/lib/api";

export type InworkState = "no_answer" | "talk" | "pending" | "none";
export type Keyed = { key: string; label: string };

export type InworkDeal = {
  id: number;
  user: string | null;
  location: string | null;
  wait_at: string | null;
  last_call_at: string | null;
  attempts: number;
  calls: number;
  row: string;
  col: string;
  state: InworkState;
  known: boolean;
};

export type DealsInwork = {
  now: string;
  since: string;
  rows: Keyed[];
  cols: Keyed[];
  states: { key: InworkState; label: string }[];
  total: number;
  unknown: number;
  redial: { total: number; by_col: Record<string, number> };
  by_row: ({ key: string; total: number } & Record<InworkState, number>)[];
  matrix: Record<"all" | InworkState, Record<string, Record<string, number>>>;
  deals: InworkDeal[];
};

export const loadDealsInwork = () => apiFetch<DealsInwork>("/api/deals/distribution/inwork");
